/* Shipping bar dates: today → ship date → delivery window, skipping Sundays. */
(() => {
  const addDays = (date, days) => {
    const d = new Date(date);
    let left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) left -= 1;
    }
    return d;
  };

  document.querySelectorAll('[data-delivery-timeline]').forEach((el) => {
    const locale = el.dataset.locale === 'fr' ? 'fr-FR' : el.dataset.locale || 'en';
    const fmt = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' });
    const today = new Date();
    const shipped = addDays(today, Number(el.dataset.shipDays) || 0);
    const from = addDays(today, Number(el.dataset.minDays) || 1);
    const to = addDays(today, Number(el.dataset.maxDays) || 3);
    const delivered = from.getTime() === to.getTime() ? fmt.format(from) : fmt.formatRange(from, to);
    [fmt.format(today), fmt.format(shipped), delivered].forEach((text, i) => {
      const slot = el.querySelector(`[data-delivery-date="${i}"]`);
      if (slot) slot.textContent = text;
    });
  });

  // Express note link opens the Chatway (WhatsApp) widget; falls back to clicking its bubble.
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-open-chat]')) return;
    if (window.$chatway?.openChatwayWidget) window.$chatway.openChatwayWidget();
    else document.querySelector('.chatway--trigger, [class*="chatway"] button')?.click();
  });
})();
